import { Component } from '@angular/core';
import { AuthService } from '../../../core/auth/auth.service';
import { LucideCircleUser } from '@lucide/angular';

@Component({
  selector: 'app-registration-success',
  imports: [LucideCircleUser],
  standalone: true,
  templateUrl: './registration-success.component.html',
  styleUrl: './registration-success.component.scss'
})
export class RegistrationSuccessComponent {
  constructor(public authService: AuthService) {}
}
